// extracted by mini-css-extract-plugin
export var dividerLine = "_6p-3";
export var itemImage = "_6p-9";
export var lightDivider = "_6p-4";
export var modalContent = "_6p-5";
export var modalContentCompact = "_6p-6";
export var productCard = "_6p-a";
export var productImage = "_6p-b";
export var productImageCompact = "_6p-7";
export var productImagePlaceholder = "_6p-c";
export var productImagePlaceholderCompact = "_6p-8";
export var progressBarBackground = "_6p-1";
export var progressBarContainer = "_6p-0";
export var progressBarFill = "_6p-2";